// DayPasses action types

const dayPassesActionTypes = {
  SET_DAYPASSES: 'SET_DAYPASSES',
  SET_DAYPASSES_AVAILABLE_DATES: 'SET_DAYPASSES_AVAILABLE_DATES',
  UPDATE_DAYPASSES_FETCHING: 'UPDATE_DAYPASSES_FETCHING',
  SET_SEASONPASS: 'SET_SEASONPASS',
  SET_SEASONPASS_CHARGES: 'SET_SEASONPASS_CHARGES',
  SET_SEASON_PASS_LOADING: 'SET_SEASON_PASS_LOADING',
  CLEAR_DAYPASSES: 'CLEAR_DAYPASSES'
};

export default dayPassesActionTypes;
